import React, {useState, useEffect} from "react"
import AuthService from '../services/authentication'
import {useHistory} from "react-router-dom"
import surveyManager from '../../services/surveyManager'

import CreateOrderForm from "../sales_orders/CreateOrderForm"
import SetMarkupForm from "./SetMarkupForm"
import SetRrpForm from "./setRrpForm"

import { Button, Modal } from "../ui"

function PractitionerIndex(props) {

	const [showModal, setShowModal] = useState(false);

	let auth = AuthService.useAuth()
	let history = useHistory()

	useEffect(() => {
		surveyManager.checkAndDisplay();
	}, []);

	const signOut = () => {
		auth.signOut()
		.then(() => history.push("/login"))
	}

	return (
		<>
		<Modal show={showModal} onHide={() => setShowModal(false)}>
		  <Modal.Header closeButton>
		    <Modal.Title>Create prescription</Modal.Title>
		  </Modal.Header>
		  <Modal.Body>
		    <CreateOrderForm  />
		  </Modal.Body>
		</Modal>
		<div className="flex justify-between">
		  <Button variant="primary" onClick={() => setShowModal(true)}>
		   	<span className="me-2">Create new prescription</span>
		  </Button>
		</div>
		<div className="mt-4 mb-4">
			<div className="flex flex-col items-start mb-4 w-full">
				<div className="w-full">
					{auth.user?.user &&
						<div className="flex">
							<p className="pt-4 pb-3">Signed in as: {auth.user.user.email}</p>
							<p onClick={signOut} className="text-gray-500 ms-2 pt-4" style={{cursor: 'pointer'}}>Logout</p>
						</div>
					}
				</div>
				<div className="w-full lg:w-1/2 mb-4">
					<SetRrpForm />
				</div>
				<div className="w-full lg:w-1/4">
					<SetMarkupForm />
				</div>
				<div className="w-full mt-8 underline">
					<a href="/practitioner-terms.pdf" target="_blank" rel="noopener noreferrer">
						View Our Terms and Conditions
					</a>
				</div>
			</div>
		</div>
		<hr />
		</>
	)
}

export default PractitionerIndex